import { render, staticRenderFns } from "./ScheduleBooking.vue?vue&type=template&id=ede633da"
import script from "./ScheduleBooking.vue?vue&type=script&lang=js"
export * from "./ScheduleBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports